import { render, staticRenderFns } from "./Pembinaan.vue?vue&type=template&id=2ab0eab9"
import script from "./Pembinaan.vue?vue&type=script&lang=js"
export * from "./Pembinaan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports